import { createContext } from "react";
import { RuntimeConfig } from "tng-address-collection-shared/types";

export const RuntimeConfigContext = createContext<RuntimeConfig>({
  idpConfig: {},
  isTestSystem: true,
  appUrls: { addressCollection: "/", portraits: "/" },
});
